import { useQuery } from "react-query";
import { fetchFixFlipData } from "./api";

export function useFixFlip(filters, options = {}) {
  return useQuery(["FixFlipsData", filters], () => fetchFixFlipData(filters), {
    staleTime: 60000 * 600,
    cacheTime: 60000 * 6000,
    refetchOnWindowFocus: false,
    ...options,
  });
}
